import bubblesOrigo from "../../assets/bubbles.svg";


const Bubbles = ({className}) => {
  return (
    <div className={className}>
      <img src={bubblesOrigo} alt="bubles background" />
    </div>
  );
};

export default Bubbles;
